import { Injectable } from "@angular/core";
import { ITravellerObject } from "libraries/service/resources/hotel/ISearchParameters";
import { IHolder, ICitizenShip, IIdentityInfo } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { TravellerXGender } from "libraries/service/resources/booking/interfaces/get-bookings.enum";

@Injectable()
export class TravellerFieldsetService {
    public buildHolder(traveller: ITravellerObject): IHolder {
        return {
            xGender: traveller.gender || TravellerXGender.male,
            lastName: traveller.lastName || '',
            firstName: traveller.firstName || '',
            birthDate: traveller.birthDate || '',
            citizenShip: this.buildCitizenShip(traveller),
        };
    }

    public buildCitizenShip(traveller: ITravellerObject): ICitizenShip {
        if (traveller.citizenship) {
            return {"country": {"code":traveller.citizenship}};
        } else if (traveller.passport?.issuance) {
            return {
                country: traveller.passport.issuance.country || traveller.passport.issuance.passCountry
            };
        } else if (traveller.identityCard?.issuance) {
            return {
                country: traveller.identityCard.issuance.country || traveller.identityCard.issuance.cardCountry
            };
        }

        return { country: {code: ''}};
    }

    public emptyIdentityInfo(traveller: ITravellerObject): IIdentityInfo {
        return {
            holder: this.buildHolder(traveller),
            number: null,
            validity: {},
            placeOfIssue: {country: {code: ''}},
        };
    }
}
